import React, { useState } from 'react';
import AdminLayout from './AdminLayout';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';

const AdminDashboard = (props) => {
  const [adminCredentials, setAdminCredentials] = useState({
    username: '',
    password: ''
  });

  // Simple hash function for password
  const simpleHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }
    return Math.abs(hash).toString(16);
  };

  const ADMIN_USERNAME = 'admin';
  const ADMIN_PASSWORD_HASH = '417b6a79'; // Password: FandE$2180

  const handleAdminLogin = () => {
    const { username, password } = adminCredentials;

    if (!username || !password) {
      alert('Please enter both username and password');
      return;
    }

    const passwordHash = simpleHash(password);

    if (username === ADMIN_USERNAME && passwordHash === ADMIN_PASSWORD_HASH) {
      // Save authentication to localStorage
      localStorage.setItem('isAdminAuthenticated', 'true');
      localStorage.setItem('adminLoginTime', Date.now().toString());

      props.setIsAdmin(true);
      props.setCurrentPage('admin');
      setAdminCredentials({ username: '', password: '' });
    } else {
      alert('Invalid username or password');
    }
  };


  // Forgot Password Page
  if (props.currentPage === 'forgot-password') {
    return <ForgotPassword setCurrentPage={props.setCurrentPage} />;
  }

  // Reset Password Page
  if (props.currentPage === 'reset-password') {
    return <ResetPassword setCurrentPage={props.setCurrentPage} />;
  }

  // Admin Login Page
  if (props.currentPage === 'admin-login') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center">
        <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl font-bold text-green-600">🔒</span>
            </div>
            <h2 className="text-2xl font-bold text-gray-800">Admin Login</h2>
            <p className="text-gray-600 mt-2">Access your dashboard</p>
          </div>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Username</label>
              <input
                type="text"
                value={adminCredentials.username}
                onChange={(e) => setAdminCredentials(prev => ({...prev, username: e.target.value}))}
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-green-500 focus:border-transparent"
                placeholder="Enter username"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
              <input
                type="password"
                value={adminCredentials.password}
                onChange={(e) => setAdminCredentials(prev => ({...prev, password: e.target.value}))}
                onKeyPress={(e) => e.key === 'Enter' && handleAdminLogin()}
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-green-500 focus:border-transparent"
                placeholder="Enter password"
                required
              />
            </div>
            <button
              onClick={handleAdminLogin}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors"
            >
              Login
            </button>
          </div>

          <div className="text-center mt-4">
            <button
              onClick={() => props.setCurrentPage('forgot-password')}
              className="text-green-600 hover:text-green-700 text-sm font-medium"
            >
              Forgot Password?
            </button>
          </div>

          <button
            onClick={() => props.setCurrentPage('welcome')}
            className="w-full mt-6 text-gray-500 hover:text-gray-700 text-sm"
          >
            ← Back to Home
          </button>
        </div>
      </div>
    );
  }

  // Admin Dashboard with Layout - FIXED: No longer recursive
  if (props.currentPage === 'admin' && props.isAdmin) {
    return <AdminLayout {...props} />;
  }

  return null;
};

export default AdminDashboard;